import TypeCheck from "typecheck-extended";

import ApiEndpoints from "../../../ApiEndpoints";
import FetchService, { asyncFetchService } from "../../../FetchService";
import {
  ConcatQueryParams,
  PaginationParams,
  RemoveNullKeys
} from "../Utilities";
import { FormatUrlV2 } from "../../../FormatUrl";

function get(
  onSuccess,
  onError,
  pagination,
  loanUuid,
  scheduleUuid,
  queryParams,
  callbackData
) {
  TypeCheck(onSuccess, "function");
  TypeCheck(onError, "function");
  TypeCheck(loanUuid, "string");
  TypeCheck(scheduleUuid, "string", false);
  TypeCheck(queryParams, "object", false);

  if (scheduleUuid && queryParams) {
    onError("Error: Invalid Filter Combination");
  }

  let appendToUrl = "";
  if (scheduleUuid) {
    appendToUrl += `/${scheduleUuid}`;
  }
  if (queryParams) {
    appendToUrl = ConcatQueryParams(queryParams);
  }
  if (pagination) {
    appendToUrl = PaginationParams(appendToUrl, pagination);
  }
  const url =
    FormatUrlV2(ApiEndpoints.loanPaymentSchedules, { loan_uuid: loanUuid }) +
    appendToUrl;

  FetchService("GET", url, onSuccess, onError, null, callbackData);
}

async function read(loanUuid, scheduleUuid, queryParams, pagination) {
  TypeCheck(loanUuid, "string", false);
  TypeCheck(scheduleUuid, "string", false);
  TypeCheck(queryParams, "object", false);
  TypeCheck(pagination, "object", false);

  let url = FormatUrlV2(ApiEndpoints.loanPaymentSchedules, {
    loan_uuid: loanUuid
  });
  if (scheduleUuid) {
    FormatUrlV2(ApiEndpoints.loanPaymentSchedule, {
      loan_uuid: loanUuid,
      uuid: scheduleUuid
    });
  }

  let appendToUrl = "";
  if (queryParams) {
    appendToUrl = ConcatQueryParams(queryParams);
  }

  if (pagination) {
    appendToUrl = PaginationParams(appendToUrl, pagination);
  }
  url += appendToUrl;

  const rsp = await asyncFetchService("GET", url);
  return rsp;
}

function update(onSuccess, onError, body, callbackData) {
  TypeCheck(onSuccess, "function");
  TypeCheck(onError, "function");
  const url = FormatUrlV2(ApiEndpoints.loanPaymentSchedule, {
    loan_uuid: body.loan_uuid,
    uuid: body.uuid
  });
  const convertedBody = RemoveNullKeys(body);

  FetchService("PUT", url, onSuccess, onError, convertedBody, callbackData);
}

function add(onSuccess, onError, body, callbackData) {
  TypeCheck(onSuccess, "function");
  TypeCheck(onError, "function");
  const url = FormatUrlV2(ApiEndpoints.loanPaymentSchedules, {
    loan_uuid: body.loan_uuid
  });
  const convertedBody = RemoveNullKeys(body);
  FetchService("POST", url, onSuccess, onError, convertedBody, callbackData);
}

async function create(loanUuid, body) {
  TypeCheck(loanUuid, "string");
  TypeCheck(body, "object");
  const url = FormatUrlV2(ApiEndpoints.loanPaymentSchedules, {
    loan_uuid: loanUuid
  });
  const convertedBody = RemoveNullKeys(body);
  const rsp = await asyncFetchService("POST", url, convertedBody);
  return rsp;
}

async function updateV2(loanUuid, scheduleUuid, body) {
  TypeCheck(loanUuid, "string");
  TypeCheck(scheduleUuid, "string");

  const url = FormatUrlV2(ApiEndpoints.loanPaymentSchedule, {
    loan_uuid: loanUuid,
    uuid: scheduleUuid
  });
  const convertedBody = RemoveNullKeys(body);

  const rsp = await asyncFetchService("PUT", url, convertedBody);
  return rsp;
}

function remove(onSuccess, onError, body, callbackData) {
  TypeCheck(onSuccess, "function");
  TypeCheck(onError, "function");
  const url = FormatUrlV2(ApiEndpoints.loanPaymentSchedule, {
    loan_uuid: body.loan_uuid,
    uuid: body.uuid
  });
  const convertedBody = RemoveNullKeys(body);
  FetchService("DELETE", url, onSuccess, onError, convertedBody, callbackData);
}

export default {
  create,
  get,
  update,
  updateV2,
  add,
  read,
  remove
};
